import React from "react";
import {
  DataGrid,
  GridColDef,
  GridToolbar,
  GridValueGetterParams,
} from "@mui/x-data-grid";

const columns: GridColDef[] = [
  { field: "id", headerName: "ID", width: 90 },

  {
    field: "code",
    headerName: "Código",
    width: 160,
  },
  {
    field: "description",
    headerName: "Descrição",
    width: 500,
  },
  {
    field: "fiscalAmount",
    headerName: "Quantidade Fiscal",
    width: 130,
  },
  {
    field: "amount",
    headerName: "Quantidade",
    width: 190,
  },
  {
    field: "difference",
    headerName: "Diferença",
    width: 190,
  },
];

type Props = {
  data: Array<{
    code: string;
    description?: string;
    fiscalAmount: number;
    amount: number;
  }>;
};

export const Table = ({ data }: Props) => {
  return (
    <div style={{ width: "100%" }}>
      <DataGrid
        rows={data}
        columns={columns}
        slots={{
          toolbar: GridToolbar,
        }}
        getRowClassName={(params) =>
          params.row.difference === 0 ? "text-green" : "text-red"
        }
        initialState={{
          columns: {
            columnVisibilityModel: {
              id: false,
            },
          },
        }}
      />
    </div>
  );
};
